import { TableCell, TableRow, Typography, useMediaQuery } from '@mui/material'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import { map } from 'lodash'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { CoinLabel } from '../../../../../components/CoinLabel'
import { useProfileStore } from '../../../../../store/storeProfile'
import { theme } from '../../../../../theme'
import { BillingStatus } from './BillingStatus'
import { BillingTableHeading } from './BillingTableHeading'
import { getAddColumns } from './constants'

export const BillingAddTable = ({}) => {
    const { t } = useTranslation()
    const { billingListAdded } = useProfileStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const ts = Intl.DateTimeFormat().resolvedOptions().timeZone

    return (
        <>
            {isMobile ? (
                <>
                    {map(billingListAdded?.objects, (billing) => {
                        return (
                            <Stack direction="column" sx={{}} spacing={1}>
                                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            textAlign: 'left',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}>
                                        {billing?.description}
                                    </Typography>
                                    + <CoinLabel coin={billing?.balance_charge} />
                                </Stack>

                                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                                    <Typography variant="caption2">
                                        {billing?.created_at &&
                                            moment(billing?.created_at)
                                                .tz(ts)
                                                .format('DD.MM.YY HH:mm')}
                                    </Typography>
                                    <BillingStatus status="ACCEPT" />
                                </Stack>
                                <Divider />
                            </Stack>
                        )
                    })}
                </>
            ) : (
                <Table stickyHeader aria-label="sticky table">
                    {billingListAdded && (
                        <>
                            <>
                                <BillingTableHeading columns={getAddColumns(t)} />
                                <TableBody>
                                    {billingListAdded?.objects?.map((billing) => {
                                        return (
                                            <TableRow key={billing?.filename}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    sx={{
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        cursor: 'pointer',
                                                    }}>
                                                    <Stack direction="column" sx={{}} spacing={1}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                maxWidth: `calc(100dvw - ${840}px)`,
                                                                // color: '#9195A1',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}>
                                                            {billing?.description}
                                                        </Typography>
                                                    </Stack>
                                                </TableCell>

                                                <TableCell align="right">
                                                    <BillingStatus status="ACCEPT" />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {billing?.created_at &&
                                                        moment(billing?.created_at)
                                                            .tz(ts)
                                                            .format('DD.MM.YY HH:mm')}
                                                </TableCell>
                                                <TableCell align="right">
                                                    + <CoinLabel coin={billing?.balance_charge} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </>
                        </>
                    )}
                </Table>
            )}
        </>
    )
}
